import { StudentData } from '../types';
import { evaluationDict } from './evaluationDict';

function getEvalText(key: string, value: number): string {
  const dict = evaluationDict as Record<string, Record<number, string>>;
  return dict[key]?.[value] ?? `数据暂未记录（值：${value}）`;
}

function buildSelfEvalReport(data: StudentData): string {
  const { selfEval } = data;
  const parts: string[] = [];

  parts.push(getEvalText('self_q1', selfEval.q1Participation));
  parts.push(getEvalText('self_q2', selfEval.q2Resilience));
  parts.push(getEvalText('self_q3', selfEval.q3SkillKnow));
  parts.push(getEvalText('self_q4', selfEval.q4SkillImprove));
  parts.push(getEvalText('self_q5', selfEval.q5HealthSafe));
  parts.push(getEvalText('self_q6', selfEval.q6HealthPrep));
  parts.push(getEvalText('self_q7', selfEval.q7MoralQueue));
  parts.push(getEvalText('self_q8', selfEval.q8MoralEncourage));
  parts.push(getEvalText('overall_star', selfEval.overallEval));

  return parts.join('；') + '。';
}

function buildPeerEvalReport(data: StudentData): string {
  if (!data.peerEval) return '';

  const { peerEval } = data;
  const parts: string[] = [];

  parts.push(getEvalText('peer_q1', peerEval.q1Emotion));
  parts.push(getEvalText('peer_q2', peerEval.q2Support));
  parts.push(getEvalText('peer_q3', peerEval.q3SafeRespect));
  parts.push(getEvalText('peer_q4', peerEval.q4Effort));

  return '【同伴评价】' + parts.join('；') + '。';
}

function buildTeacherEvalReport(data: StudentData): string {
  if (!data.teacherGroupEval) return '';

  const { teacherGroupEval } = data;
  const parts: string[] = [];

  parts.push(getEvalText('teacher_q1', teacherGroupEval.q1Complete));
  parts.push(getEvalText('teacher_q2', teacherGroupEval.q2Attitude));
  parts.push(getEvalText('teacher_q3', teacherGroupEval.q3Discipline));
  parts.push(getEvalText('teacher_q4', teacherGroupEval.q4Atmosphere));

  return '【教师评价】' + parts.join('；') + '。';
}

export function generateMicroReport(data: StudentData): string {
  const studentName = data.student.studentName;
  const selfReport = buildSelfEvalReport(data);
  const peerReport = buildPeerEvalReport(data);
  const teacherReport = buildTeacherEvalReport(data);

  let report = `【${studentName}的课堂表现】`;
  report += selfReport;

  if (peerReport) {
    report += '\n' + peerReport;
  }

  if (teacherReport) {
    report += '\n' + teacherReport;
  }

  return report;
}

export function generateAllMicroReports(studentDataList: StudentData[]): StudentData[] {
  return studentDataList.map((data) => ({
    ...data,
    microReport: generateMicroReport(data),
  }));
}

export function calculateDimensionAverages(studentDataList: StudentData[]): {
  dimension: string;
  avgScore: number;
}[] {
  if (studentDataList.length === 0) return [];

  const sums: Record<string, number> = {
    运动参与: 0,
    技能学习: 0,
    健康行为: 0,
    体育品德: 0,
  };

  const counts: Record<string, number> = {
    运动参与: 0,
    技能学习: 0,
    健康行为: 0,
    体育品德: 0,
  };

  for (const data of studentDataList) {
    sums.运动参与 += data.selfEval.q1Participation + data.selfEval.q2Resilience;
    counts.运动参与 += 2;

    sums.技能学习 += data.selfEval.q3SkillKnow + data.selfEval.q4SkillImprove;
    counts.技能学习 += 2;

    sums.健康行为 += data.selfEval.q5HealthSafe + data.selfEval.q6HealthPrep;
    counts.健康行为 += 2;

    sums.体育品德 += data.selfEval.q7MoralQueue + data.selfEval.q8MoralEncourage;
    counts.体育品德 += 2;
  }

  return Object.keys(sums).map((dimension) => ({
    dimension,
    avgScore: counts[dimension] > 0 ? sums[dimension] / counts[dimension] : 0,
  }));
}